export default {"src":"/_next/static/media/ic_edit_button_rounded.25883195.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};